import React, { useState, useEffect, memo, useMemo } from "react";
import Header from "../../layout/Header";
import { Link, useNavigate } from "react-router-dom";
// eslint-disable-next-line
import { connect } from "react-redux";
import { getCustomer, clearCustomer } from "../../../../actions/customer"
import { decrypt } from "../../../../utils/encodingdecoding";
import { getAllCustomer, getSchemaList } from "../../../../actions/auth"
import Pagination from "./Pagination";
import { Modal, CloseButton, Button } from "react-bootstrap";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { getUserTypeOptions, sobiscoMerchantId } from "../../../../utils";

const CustomersList = memo(({ getCustomer, Customer, clearCustomer }) => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [response, setResponse] = useState([]);
    const [schemaData, setSchemaData] = useState()
    const [loader, setLoader] = useState(true);
    const [selectedUserType, setSelectedUserType] = useState("all");
    const id = decrypt(localStorage.getItem("Id"))
    const [options] = useState(getUserTypeOptions(id));

    useEffect(() => {
        let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
        if (tempPageIndex === 1) {
            fetch();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setResponse(Customer?.data)
    }, [Customer])

    const updateData = () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        getSchemaList(token?.access_token).then((res) => {
            setSchemaData(res?.schema?.properties)

        });
    }

    useEffect(() => {
        updateData()
    }, [])

    useEffect(() => {
        const temp = response?.data?.data;

        if (temp) {
            const mappedData = temp.map((val) => {
                const modifiedCustomerData = {
                    ...val.customerData,
                    cpcustomertype:
                        val.customerData.cpcustomertype === "CustomerCP"
                            ? "Customer"
                            : val.customerData.cpcustomertype,
                };

                const updatedVal = {
                    ...val,
                    earnedValue: val.walletData.wallet.earnedValue,
                    availableValue: val.walletData.wallet.availableValue,
                    redeemValue: val.walletData.wallet.redeemValue,
                    action: val.customerData.customercode,
                    customerType: val.customerData.customerType,
                    customerData: modifiedCustomerData,
                };

                if (schemaData) {
                    Object.keys(schemaData).forEach((key) => {
                        if (schemaData[key].isFormView) {
                            updatedVal[key] = modifiedCustomerData[key] || "";
                        }
                    });
                }

                return updatedVal;
            });

            const finalData =
                selectedUserType === "all"
                    ? mappedData
                    : mappedData.filter(
                        (item) =>
                            (item.customerData.customerType?.toLowerCase() || item.customerData.cpcustomertype?.toLowerCase()) ===
                            selectedUserType.toLowerCase()
                    );

            setData(finalData);
        } else {
            setData([]);
        }
    }, [response, schemaData, selectedUserType]);


    const fetch = async () => {
        setLoader(true);
        await clearCustomer();
        const token = JSON.parse(localStorage.getItem("token_gen"));
        let id = localStorage.getItem("Id");
        await getCustomer(token?.access_token, id, 1, 50, "");
        setTimeout(() => {
            setLoader(false);
        }, 1000);
    };

    const dynamicColumns = useMemo(() => {
        if (!schemaData) return [];

        return Object.entries(schemaData)
            .filter(([key, item]) => {
                if (!item.isFormView) return false;

                if (selectedUserType === "all") return true;

                const temp = getUserTypeOptions(id).filter(
                    (obj) => obj.value === selectedUserType
                );

                const selectedType = temp?.[0]?.customerType;

                if (item.customerType) {
                    return item.customerType
                        .toUpperCase()
                        .includes(selectedType?.toUpperCase());
                }

                return true;
            })
            .map(([key, value]) => (
                key === "cpcustomertype"
                    ? {
                        Header: "Customer Type",
                        Footer: "Customer Type",
                        accessor: key,
                    }
                    : key === "cpkycstatus"
                        ? {
                            Header: "KYC Status",
                            Footer: "KYC Status",
                            accessor: key,
                        }
                        : {
                            Header: value.fielddisplayname || value.label || key,
                            Footer: value.fielddisplayname || value.label || key,
                            accessor: key,
                        }
            ));
    }, [schemaData, selectedUserType]);

    const columns = useMemo(() => {
        const baseColumns = [...dynamicColumns];

        if (selectedUserType === "all") {
            baseColumns.splice(1, 0, {
                Header: "User Type",
                Footer: "User Type",
                accessor: "customerType",
                Cell: ({ value }) => value || "",
            });
        }
        const staticColumns = id === sobiscoMerchantId ? [
            ...baseColumns,
            {
                Header: "Action",
                Footer: "Action",
                accessor: "action",
                Cell: ({ value }) => (
                    <Link
                        to={`/channel-partner/user-view/${value}`}
                        state={{ customerCode: value, schemaData: schemaData }}

                    >
                        <i className="fa-solid fa-eye"></i> View Details
                    </Link >
                ),
            },
        ] : [
            ...dynamicColumns,
            {
                Header: "Earned Value",
                Footer: "Earned Value",
                accessor: "earnedValue",
            },
            {
                Header: "Available Value",
                Footer: "Available Value",
                accessor: "availableValue",
            },
            {
                Header: "Redeem Value",
                Footer: "Redeem Value",
                accessor: "redeemValue",
            },

            {
                Header: "Action",
                Footer: "Action",
                accessor: "action",
                Cell: ({ value }) => (
                    <Link
                        to={`/channel-partner/user-view/${value}`}
                        state={{ customerCode: value, schemaData: schemaData }}

                    >
                        <i className="fa-solid fa-eye"></i> View Details
                    </Link >
                ),
            },
        ];
        return staticColumns;
    }, [dynamicColumns, selectedUserType]);

    const handleModal = () => {
        setShow(true);
    };

    const onHandleSelect = (e) => {
        if (e.value) {
            navigate("/channel-partner/create-user", {
                state: {
                    type: e.value,
                    formType: "create",
                    customerType: e.customerType
                },
            });
        }
    };

    const handleClose = () => setShow(false);
    const onSubmit = () => { };

    return (
        <>
            <Header name={"User Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="dashboard__heading">
                                <div className="dashboard__headingLeft">
                                    <div className="dashboard__headingContent">
                                        <Button id="crate_new_cmp" onClick={handleModal} className="btn btn-primary btn-lg">
                                            Create New User
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dashboard__customersCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>User List</h4>
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <Pagination
                                data={data}
                                tableColumns={columns}
                                loader={loader}
                                setLoader={setLoader}
                                selectedUserType={selectedUserType}
                                setSelectedUserType={setSelectedUserType}
                                setData={setData}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={show} id="showm" onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>Create New User</Modal.Title>
                    <CloseButton onClick={handleClose} variant="black" />
                </Modal.Header>
                <Modal.Body>
                    <p>Please select which type of User you want to create</p>
                    <div className="form-group">
                        <ValidatorForm onSubmit={onSubmit}>
                            <SelectValidator placeholder="Select" className="" name="choice" options={options} onChange={onHandleSelect} />
                        </ValidatorForm>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
});

const mapStateToProps = (state) => ({
    Customer: state.Customer,
});
const mapDispatchToProps = {
    getCustomer,
    clearCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersList);
